module.exports = __webpack_public_path__ + "static/media/ciniphilia_ang_signup.2733f115.gif";